<style scoped>
    .container{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,.6);
        z-index: 10000;
    }
    .scaner{
        position: absolute;
        width: 480px;
        height: 320px;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        -webkit-transform: translate(-50%,-50%);
        background: white;
    }
    .close-btn{
        display: inline-block;
        position: absolute;
        left: 50%;
        bottom: -65px;
        width: 60px;
        height: 60px;
        line-height: 58px;
        border: 2px solid white;
        border-radius: 50%;
        transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        text-align: center;
        cursor: pointer;
    }
    .close-btn:hover{
        background: #ddd;
    }
    .close-btn:active{
        background: #666;
    }
    .scan-bar{
        position: absolute;
        top: 5px;
        left: 5px;
        right: 5px;
        height: 1px;
        background: #08c14b;
        box-shadow: 0 0 8px 2px rgba(10, 160, 70, .9);
        animation: 3s scan infinite;
    }
</style>
<template>
    <div class="container" v-show="config.show">
        <div class="scaner">
            <video ref="video" width="480" height="320" autoplay></video>
            <div v-show="false">
                <canvas id="qr-canvas" ref="canvas" width="480" height="320"></canvas>
            </div>
            <div class="scan-bar"></div>
            <span class="close-btn" @click="stop()">
                <Icon size="45" color="#fff" type="md-close"></Icon>
            </span>
        </div>
    </div>
</template>
<script>
    import Util from '../../libs/util';
    import jsQR from 'jsqr';
    export default {
        data () {
            return {
                front: false,
                tracks: [],
                is_show_when_decoded: false
            }
        },
        props: ['config'],
        computed: {
            //
        },
        watch: {
            'config.show'(val){
                if(val){
                    this.start();
                }
            }
        },
        created(){
            //
        },
        mounted(){
            this.init();
        },
        methods: {
            init(){
                this.canvas = this.$refs.canvas;
                this.context = this.canvas.getContext("2d");
                this.video = this.$refs.video;

                eventHub.$on('show-qr-scaner', (callback, is_show_when_decoded)=>{
                    this.config.show = true;
                    this.callback = callback ? callback : new Function();
                    this.is_show_when_decoded = is_show_when_decoded;
                });
                eventHub.$on('hide-qr-scaner', ()=>{
                    this.config.show = false;
                    this.stop();
                });
            },
            start(){
                if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    navigator.mediaDevices.getUserMedia({
                        video: true,
                        audio: false
                    }).then((stream)=>{
                        this.tracks = stream.getTracks();
                        //window.stream = stream;
                        //this.video.src = (window.URL || window.webkitURL).createObjectURL(stream);
                        this.video.srcObject = stream;
                        this.video.setAttribute("playsinline", true);
                        this.video.play();
                        console.log('start...');
                        //摄像头启动有一定延迟
                        setTimeout(()=>{
                            this.startScan();
                        }, 300);
                    }).catch((err)=>{
                        console.log(err);
                    })
                }
            },
            stop(){
                clearInterval(this.timer);
                this.config.show = false;
                this.video.srcObject = null;
                this.video.pause();
                this.tracks.forEach((track)=>{
                    track.stop();
                });
            },
            startScan(){
                this.timer = setInterval(()=>{
                    try{
                        this.context.drawImage(this.video, 0, 0, 480, 320);
                        let imageData = this.context.getImageData(0, 0, 480, 320);
                        let code = jsQR(imageData.data, imageData.width, imageData.height);
                        if(code){
                            //识别成功的反馈
                            console.log(code);
                            this.callback(code.data);
                            //是否继续扫描
                            if(!this.is_show_when_decoded){
                                this.stop();
                            }
                        }
                        this.context.clearRect(0, 0, 480, 320);
                    }catch (e){
                        console.log(e);
                        this.stop();
                    }
                }, 200);
            }
        }
    }
</script>
